import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'lucide-react';

export default function Navbar({ activeTab, setActiveTab }) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const navItems = [
    { id: 'home', label: t('nav.home') },
    { id: 'member', label: t('nav.member') }
  ];

  const languages = ['fr', 'en', 'de'];
  const langLabels = { fr: 'FR', en: 'EN', de: 'DE' };

  return (
    <nav className="fixed top-0 w-full bg-white/90 backdrop-blur border-b border-gray-200 z-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <div className="text-xl sm:text-2xl font-light tracking-wide select-none">
          Les Amis de <span className="font-semibold">SHALOM</span>
        </div>

        {/* Mobile menu button */}
        <button
          className="sm:hidden text-gray-700"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          <Menu size={22} />
        </button>

        {/* Desktop menu */}
        <div className="hidden sm:flex items-center gap-6">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`text-sm font-light tracking-wide transition-colors ${
                activeTab === item.id
                  ? 'text-gray-900'
                  : 'text-gray-500 hover:text-gray-900'
              }`}
            >
              {item.label}
            </button>
          ))}

          <div className="flex items-center gap-2 text-sm font-light tracking-wide text-gray-500">
            {languages.map((lang, idx) => (
              <React.Fragment key={lang}>
                <button
                  onClick={() => i18n.changeLanguage(lang)}
                  className={`transition-colors ${
                    i18n.language.startsWith(lang)
                      ? 'text-gray-900 font-medium'
                      : 'hover:text-gray-900'
                  }`}
                >
                  {langLabels[lang]}
                </button>
                {idx < languages.length - 1 && (
                  <span className="text-gray-300">·</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="sm:hidden flex flex-col border-t border-gray-100 bg-white">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id);
                setOpen(false);
              }}
              className={`py-3 text-sm ${
                activeTab === item.id
                  ? 'text-gray-900'
                  : 'text-gray-500 hover:text-gray-900'
              }`}
            >
              {item.label}
            </button>
          ))}
          <div className="flex justify-center gap-3 py-2 border-t border-gray-100">
            {languages.map((lang) => (
              <button
                key={lang}
                onClick={() => i18n.changeLanguage(lang)}
                className={`text-sm ${
                  i18n.language.startsWith(lang)
                    ? 'text-gray-900 font-medium'
                    : 'text-gray-500 hover:text-gray-900'
                }`}
              >
                {langLabels[lang]}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}